import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PopConfirm from '@omilia/popconfirm';

import InspectHeader from 'components/InspectHeader';
import InspectButton from 'components/InspectButton';
import { contextType } from 'types';

class ContextInspectHeader extends Component {
  static propTypes = {
    context: contextType,
    onDelete: PropTypes.func,
  };

  static defaultProps = {
    context: {},
  };

  handleDelete = () => {
    const {
      onDelete,
      context: { id },
    } = this.props;
    onDelete(id);
  };

  render() {
    const {
      context: { archived },
    } = this.props;

    return (
      <InspectHeader>
        {!archived && (
          <PopConfirm
            confirmLabel="Yes"
            declineLabel="Cancel"
            placement="left"
            title="Are you sure you want to delete this context?"
            onConfirm={this.handleDelete}
          >
            <InspectButton isHeader data-test="inspect-context-delete-button">
              Delete context
            </InspectButton>
          </PopConfirm>
        )}
      </InspectHeader>
    );
  }
}

export default ContextInspectHeader;
